import { DONATION_BNB_TOAST_ITEMS } from '@/app/donation/constants';
import { WEL_MARKET_ROUTES } from '@/constants';

const FLOATING_BNB_DONATION_PATHS = new Set<string>([
  ...DONATION_BNB_TOAST_ITEMS.map(({ route }) => route.pathname),
]);

const FLOATING_BNB_LOCAL_MARKET_PATHS = new Set<string>([
  WEL_MARKET_ROUTES.HOME.pathname,
]);

export type FloatingBnbKind = 'donation' | 'localMarket';

export const getFloatingBnbKind = (
  pathname: string | null | undefined,
): FloatingBnbKind | null => {
  if (!pathname) return null;
  if (FLOATING_BNB_DONATION_PATHS.has(pathname)) return 'donation';
  if (FLOATING_BNB_LOCAL_MARKET_PATHS.has(pathname)) return 'localMarket';

  return null;
};
